module.exports = __webpack_public_path__ + "static/media/Cat.985d1de5.ogg";